export default {
    name: 'ajouter-travailleur',
    components: {},
    props: [],
    data() {
        return {
            error_msg: "",
            selectedPoste: '',
            loading: false,
            travailleur: {
                nom: '',
                prenoms: '',
                date_debut: '',
                telephone_mobile: "",
                telephone: "",
                poste: '',
                sexe: '',
                departement: '',
                n_matricule: ''
            },
            sexe: '',

            is_loading: true,
            // Tel input placeholder config
            options: { placeholder: "Ex. 90 00 00 00", maxlength: 11 },
            tel_is_required: false,
            country_code: '',

            prefered_countries: ['tg'],
            only_countries: ['tg', 'bj'],
            btn_disable: false
        }
    },
    computed: {
        postes(){
            return this.$store.getters['postesSelect']
        },
        sexes() {
            return this.$store.getters['sexes']
        },
        departements() {
            return this.$store.getters['departements']
        }

    },
    mounted() {
        this.$store.dispatch('getPostesSelect');
        this.$store.dispatch("getSexes")
        this.$store.dispatch("getDepartements").then(() => {
            this.is_loading = false
            
        })

    },
    methods: {
        /**
         * Clear Error message
         */
        clearError() 
        {
            this.tel_is_required = false
            console.log("Clearing")
        },

        countryChanged(country) {
            this.country_code = '+' + country.dialCode
        },


        sendTravailleur: function() {
            this.btn_disable = true
            this.loading = true;

            this.$refs.form.validate().then((success) => {
                if (!success) {
                    return;
                }

                // Check if Phone number is given
                // if (this.travailleur.telephone == '') {
                //     this.tel_is_required = true
                //     this.loading = false;
                //     return;
                // } 

                //control la date de debut
                let date_given = this.dateFormatToSend(this.travailleur.date_debut)
                let today = this.dateFormatToSend()

                if (today.date < date_given.date) {
                    this.error_msg = "La date de debut doit précéder la date de fin de contrat";
                    return;
                }
                // this.travailleur.poste_id = this.travailleur.poste_id.id
                
                let to_send = this.travailleur;

                to_send.telephone_mobile = this.country_code+' '+this.travailleur.telephone
                this.error_msg = null
                to_send.sexe = to_send.sexe.id;

                console.log("TRAV: ",to_send)
                this.$store.dispatch("saveTravailleur", { id: this.$route.params.id, data: to_send }).then(
                    (res) => {
                        this.travailleur = {
                            nom: '',
                            prenoms: '',
                            date_debut: '',
                            telephone_mobile: "",
                            telephone: "",
                            poste: '',
                            sexe: '',
                            departement: '',
                            n_matricule: '',
                        },

                        this.$refs.close_modal.click()
                        this.travailleurSuccessToast()
                        this.$refs.form.reset()

                        this.$store.dispatch('addEmployes', res)

                        this.btn_disable = false
                        this.loading = false;
                    }, error => {
                        this.loading = false;
                        this.btn_disable = false

                        if (error.response.data.errors) {
                            let errors = error.response.data.errors;
                            if (errors.telephone_mobile)
                                this.error_msg = "Ce numero de téléphone a déja été pris";

                        } else {
                            this.doErrorMsg("Erreur d'enregistrement")
                        }

                    }
                );

            });

        },
        travailleurSuccessToast: function() {
            this.$toasted.show('Le travailleur a été créé avec succès', {
                duration: 1000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);

                    }
                }],
                theme: 'toasted-primary',
                type: 'success',
                position: 'top-center'

            })
        },
        doErrorMsg: function(msg) {
            this.$toasted.show(msg, {
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                duration: 5000,
                theme: 'toasted-primary',
                type: 'error'
            })
        },

        dateFormatToSend: function(given_date) {
            let date = "";
            if (given_date)
                date = new Date(given_date)
            else
                date = new Date()

            let month = date.getMonth() + 1,
                day = date.getDate();

            if (month < 10) month = '0' + month
            let date_to_send = `${date.getFullYear()}-${month}-${day}
                                        `;
            return { date: date, date_to_send: date_to_send }
        }

    }
}